module.exports = __webpack_public_path__ + "img/yingshihui.726d516e.png";